import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';

import useStyles from './HotelGuestDropdown.style';
import clsx from 'clsx';
import SelectMUI from '../Forms/Select';
import CustomLink from '../Link';
import Typography from '../Typography';

const getWidgetDataFromProps = widgetData => {
  let extractedData = {};
  widgetData.map(data => {
    extractedData = data.fields;
    return data;
  });
  return extractedData;
};

const renderText = text => {
  return (
    <Typography variant={'subTitle'} component={'span'} gutterBottom={false}>
      <Text field={{ value: text }} />
    </Typography>
  );
};

const HotelGuestDropdown = props => {
  const classes = useStyles();
  const widgetData = getWidgetDataFromProps(props.widgetData);
  const { widget } = props;

  const renderDropdown = dropDownData => {
    const dropDown = dropDownData.map(field => {
      return (
        <SelectMUI
          data={field.fields}
          key={field.fields.fieldName.value}
          onChange={props.onWidgetDataChange}
        />
      );
    });

    return dropDown;
  };

  const renderRoomsSection = widget => {
    const roomsWidget = widget.map((data, index) => {
      return (
        <div
          className={classes.roomWrapper}
          key={`${data.roomLabel.value}_${index}`}
        >
          <div className={classes.roomHeader}>
            {renderText(`${data.roomLabel.value} ${index + 1}`)}
            {index !== 0 && (
              <CustomLink
                iconOnly={true}
                link={{
                  value: { href: '', title: '', target: '', class: '' },
                }}
                onClick={e => {
                  e.preventDefault();
                  props.onRemoveClick();
                }}
                className={classes.removeLink}
              >
                {renderText(data.removeLabel.value)}
              </CustomLink>
            )}
          </div>
          <div className={classes.guestInfoSection}>
            {renderDropdown(data.fields)}
          </div>
        </div>
      );
    });

    return roomsWidget;
  };

  return (
    <div className={clsx(classes.wrapper, props.className)}>
      <div>{renderRoomsSection(widget)}</div>
      <div className={classes.addroomSection}>
        <CustomLink
          iconOnly={true}
          link={{
            value: { href: '', title: '', target: '', class: '' },
          }}
          onClick={e => {
            e.preventDefault();
            props.onAddRoomClick();
          }}
          className={classes.addRoomLink}
        >
          {renderText(widgetData.addRoomLabel.value)}
        </CustomLink>
      </div>
    </div>
  );
};

export default HotelGuestDropdown;
